import React from 'react';
import { compact } from 'lodash/fp';
import loadable from '@loadable/component';


const pathsByMarket: Partial<Record<RouteKey, string>> = {
	home: '/',
	privacy: '/privacy',
	service: '/service',
	use: '/use',
};

const routeComponents: Record<string, React.ComponentType<any>> = {
	home: loadable(() => import('./pages/Home/Home')),
	privacy: loadable(() => import('./pages/Privacy/Privacy')),
	service: loadable(() => import('./pages/TermsOfService/TermsOfService')),
	use: loadable(() => import('./pages/TermsOfUse/TermsOfUse')),
};

type RouteKey = keyof typeof routeComponents;

export default function getPlainRoutes(routeOrder: ReadonlyArray<RouteKey> = ['home', 'about', 'privacy', 'service', 'use']) {
	return compact(
		routeOrder.map((key) => {
			const path = pathsByMarket[key];

			return path !== undefined
				? {
					path,
					component: routeComponents[key],
					exact: true,
				}
				: undefined;
		})
	);
}

type RouteParams = Record<string, string | number>;

export function interpolateParams(path: string, params?: RouteParams) {
	const parts = path.split('/');
	const replaced = parts.map((part) => {
		if (!part.startsWith(':')) return part;

		const paramKey = part.slice(1, part.includes('(') ? part.indexOf('(') : undefined);

		if (!params || !params[paramKey]) throw new Error(`Missing param '${paramKey}' for path '${path}'`);
		return params[paramKey];
	});

	return replaced.join('/');
}
